import { css } from 'lit';

export const weatherServiceAlertStyles = css`
.forecast-heading{
            font-size: 18px;
            font-family: MaerskText;
            font-weight: 700;
        }
        .forecast-heading-date{
            font-size: 16px;
            font-family: MaerskText;
            font-weight: 400;
        }
        .forecast-message {
            font-size: 13px;
            font-family: MaerskText;
            font-weight: 400;
        }
`;